import { activeInstitutionId } from '../../auth/saasSession';
import { DEFAULT_OPERATIONS_AREA_DISPLAY } from './operationsAreaOverlay';

const STORAGE_PREFIX = 'disasterms.map.operations-area-display.v1';

const userIdentity = (user) => String(
  user?._id || user?.id || user?.user_id || user?.email || '',
).trim();

export const operationsAreaPreferenceKey = (user) => {
  const identity = userIdentity(user);
  const institutionId = activeInstitutionId(user);
  if (!identity || !institutionId) return null;
  return `${STORAGE_PREFIX}:${encodeURIComponent(identity)}:${encodeURIComponent(institutionId)}`;
};

export const normalizeOperationsAreaDisplay = (value = {}) => {
  const rawIntensity = Number(value?.highlightIntensity);
  const highlightIntensity = Number.isFinite(rawIntensity)
    ? Math.min(60, Math.max(10, Math.round(rawIntensity)))
    : DEFAULT_OPERATIONS_AREA_DISPLAY.highlightIntensity;
  return {
    showCountryHighlight: value?.showCountryHighlight !== false,
    highlightIntensity,
    showWatchRadius: value?.showWatchRadius !== false,
  };
};

export const loadOperationsAreaDisplay = (user, storage = globalThis.localStorage) => {
  const key = operationsAreaPreferenceKey(user);
  if (!key || !storage) return { ...DEFAULT_OPERATIONS_AREA_DISPLAY };
  try {
    const stored = JSON.parse(storage.getItem(key) || 'null');
    return normalizeOperationsAreaDisplay(stored || DEFAULT_OPERATIONS_AREA_DISPLAY);
  } catch (error) {
    return { ...DEFAULT_OPERATIONS_AREA_DISPLAY };
  }
};

export const saveOperationsAreaDisplay = (user, value, storage = globalThis.localStorage) => {
  const key = operationsAreaPreferenceKey(user);
  const normalized = normalizeOperationsAreaDisplay(value);
  if (!key || !storage) return normalized;
  storage.setItem(key, JSON.stringify(normalized));
  return normalized;
};

export const resetOperationsAreaDisplay = (user, storage = globalThis.localStorage) => {
  const key = operationsAreaPreferenceKey(user);
  if (key && storage) storage.removeItem(key);
  return { ...DEFAULT_OPERATIONS_AREA_DISPLAY };
};
